/**
 * Escrituras de la lección high-priest-1 (llaves). DyC 20:60 alineado con scriptures.training.core3.
 */
import type { Scripture } from './scriptures';

export const highPriest1TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-20-60',
    reference: 'Doctrina y Convenios 20:60',
    text:
      'Todo élder, presbítero, maestro y diácono será ordenado de acuerdo con los dones y llamamientos de Dios para él; y será ordenado por el poder del Espíritu Santo que está en aquel que lo ordena.',
    verses: [
      {
        verse: 60,
        text: 'Todo élder, presbítero, maestro y diácono será ordenado de acuerdo con los dones y llamamientos de Dios para él; y será ordenado por el poder del Espíritu Santo que está en aquel que lo ordena.',
      },
    ],
    context: 'El sacerdocio se confiere por el poder del Espíritu Santo en quien ordena.',
  },
];
